module.exports = "/packs/thumbnail_coaching-d5385b1d76c58039e248c0be53c1fb0a.png";